import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';
import Request, { GetRequestsFilter } from 'gql/Request';
import ActionState, { ActionStatus } from 'store/ActionState';
import PagerState, { buildPagerState, PagerStatus } from 'store/PagerState';

export type RequestListState = {
  requests: EntityState<Request>;
  requestState: ActionState;
  pagerState: PagerState;
};

export const requestAdapter = createEntityAdapter<Request>();

export const initialState: RequestListState = {
  requests: requestAdapter.getInitialState(),
  requestState: { status: ActionStatus.IDLE },
  pagerState: {
    status: PagerStatus.HIDDEN,
  },
};

const RequestListSlice = createSlice({
  name: 'requestList',
  initialState,
  reducers: {
    listRequests: (state, _: PayloadAction<GetRequestsFilter>): RequestListState => {
      return { ...state, requestState: { status: ActionStatus.PROCESSING } };
    },
    listRequestsSucceeded: (state, action: PayloadAction<Request[]>): RequestListState => {
      return {
        ...state,
        requests:
          // the ternary below prevents `cannot call get on a revoked proxy` with 2 empty lists
          action.payload.length === 0
            ? state.requests
            : requestAdapter.upsertMany(
                state.requests ? { ...state.requests } : requestAdapter.getInitialState(),
                action.payload
              ),
        requestState: { status: ActionStatus.SUCCEEDED },
        pagerState: buildPagerState(state.pagerState, action.payload),
      };
    },
    listRequestsFailed: (state, action: PayloadAction<Error>): RequestListState => {
      return {
        ...state,
        requestState: { status: ActionStatus.FAILED, error: action.payload },
      };
    },
    clearState: () => {
      return initialState;
    },
  },
});

export default RequestListSlice;
